"use client";

import { useState } from "react";

export default function ProductImageGallery({
  images,
  title,
}: {
  images: string[];
  title: string;
}) {
  const [selected, setSelected] = useState(0);
  const [imgError, setImgError] = useState(false);

  return (
    <>
      <div className="bg-gray-100 rounded-xl overflow-hidden">
        {images.length > 0 ? (
          imgError ? (
            <div className="w-full h-[400px] lg:h-[500px] bg-gray-200 flex items-center justify-center text-gray-400">
              No Image
            </div>
          ) : (
            <img
              src={images[selected]}
              alt={`${title} ${selected + 1}`}
              className="w-full h-[400px] lg:h-[500px] object-cover"
              onError={() => setImgError(true)}
            />
          )
        ) : (
          <div className="w-full h-[400px] lg:h-[500px] bg-gray-200 flex items-center justify-center text-gray-400">
            No Image
          </div>
        )}
      </div>

      {images.length > 1 && (
        <div className="flex gap-3 mt-4 overflow-x-auto pb-2">
          {images.map((img, idx) => (
            <button
              key={idx}
              onClick={() => { setSelected(idx); setImgError(false); }}
              className={`w-20 h-20 rounded-lg overflow-hidden bg-gray-100 shrink-0 border-2 transition-colors cursor-pointer ${
                idx === selected ? "border-brand-500" : "border-transparent hover:border-brand-300"
              }`}
            >
              <img
                src={img}
                alt={`${title} ${idx + 1}`}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      )}
    </>
  );
}
